module.exports = __webpack_public_path__ + "media/application/images/footer-logo-11a3b055b193d0da96e8c0dcdc340299.svg";